import { render } from "./CreateQuickEventModal.vue?vue&type=template&id=bbf3fb74&scoped=true"
import script from "./CreateQuickEventModal.vue?vue&type=script&lang=js"
export * from "./CreateQuickEventModal.vue?vue&type=script&lang=js"

import "./CreateQuickEventModal.vue?vue&type=style&index=0&id=bbf3fb74&scoped=true&lang=css"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf3fb74"]])

export default __exports__